import { shopApiPost } from 'widgets/product/ui/api/shopApiPost';
import { toast } from 'react-toastify';

const shopCreateApi = shopApiPost.injectEndpoints({
  endpoints: (builder) => ({
    createProduct: builder.mutation({
      query: (body) => ({
        url: '/shop/admin/v1/product/create-product',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при создании товара';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Товар успешно создан', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'CreateShops', id: arg.id },
          { type: 'CreateShops', id: 'ALL' },
        ];
      },
    }),
    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `/shop/admin/v1/product/delete-product-by-id?product_id=${productId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при удалении товара';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили товар', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'CreateShops', id: arg.id },
          { type: 'CreateShops', id: 'ALL' },
        ];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useCreateProductMutation, useDeleteProductMutation } = shopCreateApi;
